import React from "react";
import styled from "styled-components";
import { FlexContainer, portalColors } from "src/components";
import { CardSkeleton } from "./CardSkeleton";

const Card = styled.div`
  height: 83px;
  aspect-ratio: 9 / 16;
  border: 1px solid ${portalColors.border};
  border-radius: 7px;
  box-shadow: 0px 3px 6px #00000029;
  background: ${portalColors.surface};
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const QuoteImageCard = ({ src, loading }) => {
    return (
        <FlexContainer>
            <Card>
                {loading ? (
                    <CardSkeleton height="83px" />
                ) : (
                    <Image src={src} alt="Quote Preview" />
                )}
            </Card>
        </FlexContainer>
    );
};
